// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: maintenance.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "./google/protobuf/timestamp";
import { Todo } from "./todo";

export const protobufPackage = "familyos.v1";

/**
 * Family OS — Home Maintenance plugin models.
 *
 * Note on drift: the handler response JSON (applianceJSON,
 * recordJSON) exposes both old and new field names for
 * manufacturer/brand, install_date/purchase_date, warranty_until/
 * warranty_expiry, contractor_name/contractor — a transitional alias
 * layer. Proto models the canonical (new) fields; clients that read
 * the legacy aliases get them via handler-side marshaling until the
 * aliases are removed.
 */

export interface Appliance {
  id: string;
  household_id: string;
  owner_id: string;
  name: string;
  /** "appliance" | "hvac" | "plumbing" | "electrical" */
  category: string;
  manufacturer?: string | undefined;
  model_number?: string | undefined;
  install_date?: string | undefined;
  warranty_until?: string | undefined;
  location?: string | undefined;
  notes?: string | undefined;
  created_at?: string | undefined;
  updated_at?: string | undefined;
}

export interface ServiceRecord {
  id: string;
  appliance_id: string;
  household_id: string;
  todo_id?:
    | string
    | undefined;
  /** "inspection" | "repair" | "replacement" */
  service_type: string;
  contractor_name?: string | undefined;
  cost?: number | undefined;
  scheduled_at?: string | undefined;
  completed_at?: string | undefined;
  next_due_date?: string | undefined;
  notes?: string | undefined;
  owner_id: string;
  created_at?: string | undefined;
  updated_at?: string | undefined;
}

export interface UpcomingMaintenanceItem {
  appliance_id: string;
  appliance_name: string;
  service_type: string;
  due_at?:
    | string
    | undefined;
  /** "overdue" | "soon" | "later" */
  urgency: string;
}

/** context_blob for type_tag: "maintenance.service_call" */
export interface ServiceCallContext {
  appliance_id?: string | undefined;
  appliance_name?: string | undefined;
  contractor_name?: string | undefined;
  contractor_phone?: string | undefined;
  service_type?: string | undefined;
  estimated_cost?: number | undefined;
}

/** context_blob for type_tag: "maintenance.inspection" */
export interface InspectionContext {
  appliance_id?: string | undefined;
  appliance_name?:
    | string
    | undefined;
  /** "annual" | "quarterly" | "ad_hoc" */
  inspection_type?: string | undefined;
  last_inspection_date?: string | undefined;
}

export interface CreateApplianceRequest {
  name: string;
  category?: string | undefined;
  manufacturer?: string | undefined;
  model_number?: string | undefined;
  location?: string | undefined;
  install_date?: string | undefined;
  warranty_until?: string | undefined;
  notes?: string | undefined;
}

export interface UpdateApplianceRequest {
  name?: string | undefined;
  category?: string | undefined;
  manufacturer?: string | undefined;
  model_number?: string | undefined;
  location?: string | undefined;
  install_date?: string | undefined;
  warranty_until?: string | undefined;
  notes?: string | undefined;
}

export interface CreateServiceRecordRequest {
  service_type: string;
  contractor_name?: string | undefined;
  cost?: number | undefined;
  scheduled_at?: string | undefined;
  next_due_date?: string | undefined;
  notes?: string | undefined;
}

export interface ApplianceListResponse {
  items: Appliance[];
}

export interface ServiceRecordListResponse {
  items: ServiceRecord[];
}

export interface UpcomingMaintenanceResponse {
  items: UpcomingMaintenanceItem[];
}

/**
 * Todos linked to an appliance via context_blob.appliance_id. Todo is the
 * canonical todo message defined in todo.proto (same familyos.v1 package).
 */
export interface ApplianceTodosResponse {
  todos: Todo[];
}

export interface GetApplianceRequest {
  id: string;
}

export interface UpdateAppliancePathRequest {
  id: string;
  name?: string | undefined;
  category?: string | undefined;
  manufacturer?: string | undefined;
  model_number?: string | undefined;
  location?: string | undefined;
  install_date?: string | undefined;
  warranty_until?: string | undefined;
  notes?: string | undefined;
}

export interface DeleteApplianceRequest {
  id: string;
}

export interface CreateServiceRecordPathRequest {
  id: string;
  service_type: string;
  contractor_name?: string | undefined;
  cost?: number | undefined;
  scheduled_at?: string | undefined;
  next_due_date?: string | undefined;
  notes?: string | undefined;
}

export interface ListServiceRecordsRequest {
  id: string;
}

export interface GetServiceRecordRequest {
  id: string;
  record_id: string;
}

export interface UpdateServiceRecordRequest {
  id: string;
  record_id: string;
  service_type?: string | undefined;
  contractor_name?: string | undefined;
  cost?: number | undefined;
  scheduled_at?: string | undefined;
  completed_at?: string | undefined;
  next_due_date?: string | undefined;
  notes?: string | undefined;
}

export interface DeleteServiceRecordRequest {
  id: string;
  record_id: string;
}

/**
 * ResearchSource is one source document the agent matched to this
 * appliance, plus chores' fetch/archival provenance. When storj is
 * enabled and the fetch succeeded, storj_sha addresses the stored copy
 * of the original document. When the fetch failed, fetch_error explains
 * why and the url/title are still surfaced so the operator can open it
 * directly.
 */
export interface ResearchSource {
  id: string;
  url: string;
  title: string;
  /** "manual" | "spec" | "article" */
  kind: string;
  /** "high" | "medium" | "low" */
  match_confidence: string;
  why_matches: string;
  /** storj content address of the archived original ("" when not stored). */
  storj_sha: string;
  content_type: string;
  byte_size: string;
  /** Non-empty when chores could not fetch+store the document. */
  fetch_error: string;
}

/**
 * ProposedTask is one recurring maintenance task the agent proposes (and
 * the operator may edit) before it becomes a recurring todo. Used both in
 * the research result (proposals) and the apply request (operator-edited).
 */
export interface ProposedTask {
  title: string;
  /** RFC5545 RRULE body (no "RRULE:" prefix), e.g. "FREQ=MONTHLY;INTERVAL=3". */
  interval_rrule: string;
  description: string;
  source_url: string;
}

/** ResearchResult is the latest research run for an appliance. */
export interface ResearchResult {
  id: string;
  appliance_id: string;
  /** "pending" | "running" | "complete" | "failed" */
  status: string;
  matched: boolean;
  match_rationale: string;
  /** Markdown summary of the maintenance schedule. */
  summary: string;
  /** Populated when status == "failed". */
  error: string;
  workflow_id: string;
  sources: ResearchSource[];
  tasks: ProposedTask[];
  created_at?: string | undefined;
  updated_at?: string | undefined;
}

export interface StartResearchResponse {
  workflow_id: string;
  research_id: string;
}

export interface ApplyResearchRequest {
  /** Appliance id (path). */
  id: string;
  /** Research run id (path). */
  research_id: string;
  /** Operator-reviewed tasks to materialize as recurring todos. */
  tasks: ProposedTask[];
}

export interface ApplyResearchResponse {
  created_todo_ids: string[];
}

function createBaseAppliance(): Appliance {
  return {
    id: "",
    household_id: "",
    owner_id: "",
    name: "",
    category: "",
    manufacturer: undefined,
    model_number: undefined,
    install_date: undefined,
    warranty_until: undefined,
    location: undefined,
    notes: undefined,
    created_at: undefined,
    updated_at: undefined,
  };
}

export const Appliance: MessageFns<Appliance> = {
  encode(message: Appliance, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.household_id !== "") {
      writer.uint32(18).string(message.household_id);
    }
    if (message.owner_id !== "") {
      writer.uint32(26).string(message.owner_id);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.category !== "") {
      writer.uint32(42).string(message.category);
    }
    if (message.manufacturer !== undefined) {
      writer.uint32(50).string(message.manufacturer);
    }
    if (message.model_number !== undefined) {
      writer.uint32(58).string(message.model_number);
    }
    if (message.install_date !== undefined) {
      writer.uint32(66).string(message.install_date);
    }
    if (message.warranty_until !== undefined) {
      writer.uint32(74).string(message.warranty_until);
    }
    if (message.location !== undefined) {
      writer.uint32(82).string(message.location);
    }
    if (message.notes !== undefined) {
      writer.uint32(90).string(message.notes);
    }
    if (message.created_at !== undefined) {
      Timestamp.encode(toTimestamp(message.created_at), writer.uint32(98).fork()).join();
    }
    if (message.updated_at !== undefined) {
      Timestamp.encode(toTimestamp(message.updated_at), writer.uint32(106).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Appliance {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAppliance();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.household_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.owner_id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.category = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.manufacturer = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.model_number = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.install_date = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.warranty_until = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.location = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.notes = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.created_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.updated_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Appliance {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      household_id: isSet(object.household_id) ? globalThis.String(object.household_id) : "",
      owner_id: isSet(object.owner_id) ? globalThis.String(object.owner_id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      category: isSet(object.category) ? globalThis.String(object.category) : "",
      manufacturer: isSet(object.manufacturer) ? globalThis.String(object.manufacturer) : undefined,
      model_number: isSet(object.model_number) ? globalThis.String(object.model_number) : undefined,
      install_date: isSet(object.install_date) ? globalThis.String(object.install_date) : undefined,
      warranty_until: isSet(object.warranty_until) ? globalThis.String(object.warranty_until) : undefined,
      location: isSet(object.location) ? globalThis.String(object.location) : undefined,
      notes: isSet(object.notes) ? globalThis.String(object.notes) : undefined,
      created_at: isSet(object.created_at) ? globalThis.String(object.created_at) : undefined,
      updated_at: isSet(object.updated_at) ? globalThis.String(object.updated_at) : undefined,
    };
  },

  toJSON(message: Appliance): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.household_id !== "") {
      obj.household_id = message.household_id;
    }
    if (message.owner_id !== "") {
      obj.owner_id = message.owner_id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.category !== "") {
      obj.category = message.category;
    }
    if (message.manufacturer !== undefined) {
      obj.manufacturer = message.manufacturer;
    }
    if (message.model_number !== undefined) {
      obj.model_number = message.model_number;
    }
    if (message.install_date !== undefined) {
      obj.install_date = message.install_date;
    }
    if (message.warranty_until !== undefined) {
      obj.warranty_until = message.warranty_until;
    }
    if (message.location !== undefined) {
      obj.location = message.location;
    }
    if (message.notes !== undefined) {
      obj.notes = message.notes;
    }
    if (message.created_at !== undefined) {
      obj.created_at = message.created_at;
    }
    if (message.updated_at !== undefined) {
      obj.updated_at = message.updated_at;
    }
    return obj;
  },

  create(base?: DeepPartial<Appliance>): Appliance {
    return Appliance.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Appliance>): Appliance {
    const message = createBaseAppliance();
    message.id = object.id ?? "";
    message.household_id = object.household_id ?? "";
    message.owner_id = object.owner_id ?? "";
    message.name = object.name ?? "";
    message.category = object.category ?? "";
    message.manufacturer = object.manufacturer ?? undefined;
    message.model_number = object.model_number ?? undefined;
    message.install_date = object.install_date ?? undefined;
    message.warranty_until = object.warranty_until ?? undefined;
    message.location = object.location ?? undefined;
    message.notes = object.notes ?? undefined;
    message.created_at = object.created_at ?? undefined;
    message.updated_at = object.updated_at ?? undefined;
    return message;
  },
};

function createBaseServiceRecord(): ServiceRecord {
  return {
    id: "",
    appliance_id: "",
    household_id: "",
    todo_id: undefined,
    service_type: "",
    contractor_name: undefined,
    cost: undefined,
    scheduled_at: undefined,
    completed_at: undefined,
    next_due_date: undefined,
    notes: undefined,
    owner_id: "",
    created_at: undefined,
    updated_at: undefined,
  };
}

export const ServiceRecord: MessageFns<ServiceRecord> = {
  encode(message: ServiceRecord, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.appliance_id !== "") {
      writer.uint32(18).string(message.appliance_id);
    }
    if (message.household_id !== "") {
      writer.uint32(26).string(message.household_id);
    }
    if (message.todo_id !== undefined) {
      writer.uint32(34).string(message.todo_id);
    }
    if (message.service_type !== "") {
      writer.uint32(42).string(message.service_type);
    }
    if (message.contractor_name !== undefined) {
      writer.uint32(50).string(message.contractor_name);
    }
    if (message.cost !== undefined) {
      writer.uint32(57).double(message.cost);
    }
    if (message.scheduled_at !== undefined) {
      Timestamp.encode(toTimestamp(message.scheduled_at), writer.uint32(66).fork()).join();
    }
    if (message.completed_at !== undefined) {
      Timestamp.encode(toTimestamp(message.completed_at), writer.uint32(74).fork()).join();
    }
    if (message.next_due_date !== undefined) {
      Timestamp.encode(toTimestamp(message.next_due_date), writer.uint32(82).fork()).join();
    }
    if (message.notes !== undefined) {
      writer.uint32(90).string(message.notes);
    }
    if (message.owner_id !== "") {
      writer.uint32(98).string(message.owner_id);
    }
    if (message.created_at !== undefined) {
      Timestamp.encode(toTimestamp(message.created_at), writer.uint32(106).fork()).join();
    }
    if (message.updated_at !== undefined) {
      Timestamp.encode(toTimestamp(message.updated_at), writer.uint32(114).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServiceRecord {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServiceRecord();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.appliance_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.household_id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.todo_id = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.service_type = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.contractor_name = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.cost = reader.double();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.scheduled_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.completed_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.next_due_date = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.notes = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.owner_id = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.created_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.updated_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServiceRecord {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      appliance_id: isSet(object.appliance_id) ? globalThis.String(object.appliance_id) : "",
      household_id: isSet(object.household_id) ? globalThis.String(object.household_id) : "",
      todo_id: isSet(object.todo_id) ? globalThis.String(object.todo_id) : undefined,
      service_type: isSet(object.service_type) ? globalThis.String(object.service_type) : "",
      contractor_name: isSet(object.contractor_name) ? globalThis.String(object.contractor_name) : undefined,
      cost: isSet(object.cost) ? globalThis.Number(object.cost) : undefined,
      scheduled_at: isSet(object.scheduled_at) ? globalThis.String(object.scheduled_at) : undefined,
      completed_at: isSet(object.completed_at) ? globalThis.String(object.completed_at) : undefined,
      next_due_date: isSet(object.next_due_date) ? globalThis.String(object.next_due_date) : undefined,
      notes: isSet(object.notes) ? globalThis.String(object.notes) : undefined,
      owner_id: isSet(object.owner_id) ? globalThis.String(object.owner_id) : "",
      created_at: isSet(object.created_at) ? globalThis.String(object.created_at) : undefined,
      updated_at: isSet(object.updated_at) ? globalThis.String(object.updated_at) : undefined,
    };
  },

  toJSON(message: ServiceRecord): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.appliance_id !== "") {
      obj.appliance_id = message.appliance_id;
    }
    if (message.household_id !== "") {
      obj.household_id = message.household_id;
    }
    if (message.todo_id !== undefined) {
      obj.todo_id = message.todo_id;
    }
    if (message.service_type !== "") {
      obj.service_type = message.service_type;
    }
    if (message.contractor_name !== undefined) {
      obj.contractor_name = message.contractor_name;
    }
    if (message.cost !== undefined) {
      obj.cost = message.cost;
    }
    if (message.scheduled_at !== undefined) {
      obj.scheduled_at = message.scheduled_at;
    }
    if (message.completed_at !== undefined) {
      obj.completed_at = message.completed_at;
    }
    if (message.next_due_date !== undefined) {
      obj.next_due_date = message.next_due_date;
    }
    if (message.notes !== undefined) {
      obj.notes = message.notes;
    }
    if (message.owner_id !== "") {
      obj.owner_id = message.owner_id;
    }
    if (message.created_at !== undefined) {
      obj.created_at = message.created_at;
    }
    if (message.updated_at !== undefined) {
      obj.updated_at = message.updated_at;
    }
    return obj;
  },

  create(base?: DeepPartial<ServiceRecord>): ServiceRecord {
    return ServiceRecord.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ServiceRecord>): ServiceRecord {
    const message = createBaseServiceRecord();
    message.id = object.id ?? "";
    message.appliance_id = object.appliance_id ?? "";
    message.household_id = object.household_id ?? "";
    message.todo_id = object.todo_id ?? undefined;
    message.service_type = object.service_type ?? "";
    message.contractor_name = object.contractor_name ?? undefined;
    message.cost = object.cost ?? undefined;
    message.scheduled_at = object.scheduled_at ?? undefined;
    message.completed_at = object.completed_at ?? undefined;
    message.next_due_date = object.next_due_date ?? undefined;
    message.notes = object.notes ?? undefined;
    message.owner_id = object.owner_id ?? "";
    message.created_at = object.created_at ?? undefined;
    message.updated_at = object.updated_at ?? undefined;
    return message;
  },
};

function createBaseUpcomingMaintenanceItem(): UpcomingMaintenanceItem {
  return { appliance_id: "", appliance_name: "", service_type: "", due_at: undefined, urgency: "" };
}

export const UpcomingMaintenanceItem: MessageFns<UpcomingMaintenanceItem> = {
  encode(message: UpcomingMaintenanceItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.appliance_id !== "") {
      writer.uint32(10).string(message.appliance_id);
    }
    if (message.appliance_name !== "") {
      writer.uint32(18).string(message.appliance_name);
    }
    if (message.service_type !== "") {
      writer.uint32(26).string(message.service_type);
    }
    if (message.due_at !== undefined) {
      Timestamp.encode(toTimestamp(message.due_at), writer.uint32(34).fork()).join();
    }
    if (message.urgency !== "") {
      writer.uint32(42).string(message.urgency);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpcomingMaintenanceItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpcomingMaintenanceItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.appliance_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.appliance_name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.service_type = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.due_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.urgency = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpcomingMaintenanceItem {
    return {
      appliance_id: isSet(object.appliance_id) ? globalThis.String(object.appliance_id) : "",
      appliance_name: isSet(object.appliance_name) ? globalThis.String(object.appliance_name) : "",
      service_type: isSet(object.service_type) ? globalThis.String(object.service_type) : "",
      due_at: isSet(object.due_at) ? globalThis.String(object.due_at) : undefined,
      urgency: isSet(object.urgency) ? globalThis.String(object.urgency) : "",
    };
  },

  toJSON(message: UpcomingMaintenanceItem): unknown {
    const obj: any = {};
    if (message.appliance_id !== "") {
      obj.appliance_id = message.appliance_id;
    }
    if (message.appliance_name !== "") {
      obj.appliance_name = message.appliance_name;
    }
    if (message.service_type !== "") {
      obj.service_type = message.service_type;
    }
    if (message.due_at !== undefined) {
      obj.due_at = message.due_at;
    }
    if (message.urgency !== "") {
      obj.urgency = message.urgency;
    }
    return obj;
  },

  create(base?: DeepPartial<UpcomingMaintenanceItem>): UpcomingMaintenanceItem {
    return UpcomingMaintenanceItem.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpcomingMaintenanceItem>): UpcomingMaintenanceItem {
    const message = createBaseUpcomingMaintenanceItem();
    message.appliance_id = object.appliance_id ?? "";
    message.appliance_name = object.appliance_name ?? "";
    message.service_type = object.service_type ?? "";
    message.due_at = object.due_at ?? undefined;
    message.urgency = object.urgency ?? "";
    return message;
  },
};

function createBaseServiceCallContext(): ServiceCallContext {
  return {
    appliance_id: undefined,
    appliance_name: undefined,
    contractor_name: undefined,
    contractor_phone: undefined,
    service_type: undefined,
    estimated_cost: undefined,
  };
}

export const ServiceCallContext: MessageFns<ServiceCallContext> = {
  encode(message: ServiceCallContext, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.appliance_id !== undefined) {
      writer.uint32(10).string(message.appliance_id);
    }
    if (message.appliance_name !== undefined) {
      writer.uint32(18).string(message.appliance_name);
    }
    if (message.contractor_name !== undefined) {
      writer.uint32(26).string(message.contractor_name);
    }
    if (message.contractor_phone !== undefined) {
      writer.uint32(34).string(message.contractor_phone);
    }
    if (message.service_type !== undefined) {
      writer.uint32(42).string(message.service_type);
    }
    if (message.estimated_cost !== undefined) {
      writer.uint32(49).double(message.estimated_cost);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServiceCallContext {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServiceCallContext();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.appliance_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.appliance_name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.contractor_name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.contractor_phone = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.service_type = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.estimated_cost = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServiceCallContext {
    return {
      appliance_id: isSet(object.appliance_id) ? globalThis.String(object.appliance_id) : undefined,
      appliance_name: isSet(object.appliance_name) ? globalThis.String(object.appliance_name) : undefined,
      contractor_name: isSet(object.contractor_name) ? globalThis.String(object.contractor_name) : undefined,
      contractor_phone: isSet(object.contractor_phone) ? globalThis.String(object.contractor_phone) : undefined,
      service_type: isSet(object.service_type) ? globalThis.String(object.service_type) : undefined,
      estimated_cost: isSet(object.estimated_cost) ? globalThis.Number(object.estimated_cost) : undefined,
    };
  },

  toJSON(message: ServiceCallContext): unknown {
    const obj: any = {};
    if (message.appliance_id !== undefined) {
      obj.appliance_id = message.appliance_id;
    }
    if (message.appliance_name !== undefined) {
      obj.appliance_name = message.appliance_name;
    }
    if (message.contractor_name !== undefined) {
      obj.contractor_name = message.contractor_name;
    }
    if (message.contractor_phone !== undefined) {
      obj.contractor_phone = message.contractor_phone;
    }
    if (message.service_type !== undefined) {
      obj.service_type = message.service_type;
    }
    if (message.estimated_cost !== undefined) {
      obj.estimated_cost = message.estimated_cost;
    }
    return obj;
  },

  create(base?: DeepPartial<ServiceCallContext>): ServiceCallContext {
    return ServiceCallContext.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ServiceCallContext>): ServiceCallContext {
    const message = createBaseServiceCallContext();
    message.appliance_id = object.appliance_id ?? undefined;
    message.appliance_name = object.appliance_name ?? undefined;
    message.contractor_name = object.contractor_name ?? undefined;
    message.contractor_phone = object.contractor_phone ?? undefined;
    message.service_type = object.service_type ?? undefined;
    message.estimated_cost = object.estimated_cost ?? undefined;
    return message;
  },
};

function createBaseInspectionContext(): InspectionContext {
  return {
    appliance_id: undefined,
    appliance_name: undefined,
    inspection_type: undefined,
    last_inspection_date: undefined,
  };
}

export const InspectionContext: MessageFns<InspectionContext> = {
  encode(message: InspectionContext, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.appliance_id !== undefined) {
      writer.uint32(10).string(message.appliance_id);
    }
    if (message.appliance_name !== undefined) {
      writer.uint32(18).string(message.appliance_name);
    }
    if (message.inspection_type !== undefined) {
      writer.uint32(26).string(message.inspection_type);
    }
    if (message.last_inspection_date !== undefined) {
      writer.uint32(34).string(message.last_inspection_date);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InspectionContext {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInspectionContext();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.appliance_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.appliance_name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.inspection_type = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.last_inspection_date = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InspectionContext {
    return {
      appliance_id: isSet(object.appliance_id) ? globalThis.String(object.appliance_id) : undefined,
      appliance_name: isSet(object.appliance_name) ? globalThis.String(object.appliance_name) : undefined,
      inspection_type: isSet(object.inspection_type) ? globalThis.String(object.inspection_type) : undefined,
      last_inspection_date: isSet(object.last_inspection_date)
        ? globalThis.String(object.last_inspection_date)
        : undefined,
    };
  },

  toJSON(message: InspectionContext): unknown {
    const obj: any = {};
    if (message.appliance_id !== undefined) {
      obj.appliance_id = message.appliance_id;
    }
    if (message.appliance_name !== undefined) {
      obj.appliance_name = message.appliance_name;
    }
    if (message.inspection_type !== undefined) {
      obj.inspection_type = message.inspection_type;
    }
    if (message.last_inspection_date !== undefined) {
      obj.last_inspection_date = message.last_inspection_date;
    }
    return obj;
  },

  create(base?: DeepPartial<InspectionContext>): InspectionContext {
    return InspectionContext.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<InspectionContext>): InspectionContext {
    const message = createBaseInspectionContext();
    message.appliance_id = object.appliance_id ?? undefined;
    message.appliance_name = object.appliance_name ?? undefined;
    message.inspection_type = object.inspection_type ?? undefined;
    message.last_inspection_date = object.last_inspection_date ?? undefined;
    return message;
  },
};

function createBaseCreateApplianceRequest(): CreateApplianceRequest {
  return {
    name: "",
    category: undefined,
    manufacturer: undefined,
    model_number: undefined,
    location: undefined,
    install_date: undefined,
    warranty_until: undefined,
    notes: undefined,
  };
}

export const CreateApplianceRequest: MessageFns<CreateApplianceRequest> = {
  encode(message: CreateApplianceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.category !== undefined) {
      writer.uint32(18).string(message.category);
    }
    if (message.manufacturer !== undefined) {
      writer.uint32(26).string(message.manufacturer);
    }
    if (message.model_number !== undefined) {
      writer.uint32(34).string(message.model_number);
    }
    if (message.location !== undefined) {
      writer.uint32(42).string(message.location);
    }
    if (message.install_date !== undefined) {
      writer.uint32(50).string(message.install_date);
    }
    if (message.warranty_until !== undefined) {
      writer.uint32(58).string(message.warranty_until);
    }
    if (message.notes !== undefined) {
      writer.uint32(66).string(message.notes);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateApplianceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateApplianceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.category = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.manufacturer = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.model_number = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.location = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.install_date = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.warranty_until = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.notes = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateApplianceRequest {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      category: isSet(object.category) ? globalThis.String(object.category) : undefined,
      manufacturer: isSet(object.manufacturer) ? globalThis.String(object.manufacturer) : undefined,
      model_number: isSet(object.model_number) ? globalThis.String(object.model_number) : undefined,
      location: isSet(object.location) ? globalThis.String(object.location) : undefined,
      install_date: isSet(object.install_date) ? globalThis.String(object.install_date) : undefined,
      warranty_until: isSet(object.warranty_until) ? globalThis.String(object.warranty_until) : undefined,
      notes: isSet(object.notes) ? globalThis.String(object.notes) : undefined,
    };
  },

  toJSON(message: CreateApplianceRequest): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.category !== undefined) {
      obj.category = message.category;
    }
    if (message.manufacturer !== undefined) {
      obj.manufacturer = message.manufacturer;
    }
    if (message.model_number !== undefined) {
      obj.model_number = message.model_number;
    }
    if (message.location !== undefined) {
      obj.location = message.location;
    }
    if (message.install_date !== undefined) {
      obj.install_date = message.install_date;
    }
    if (message.warranty_until !== undefined) {
      obj.warranty_until = message.warranty_until;
    }
    if (message.notes !== undefined) {
      obj.notes = message.notes;
    }
    return obj;
  },

  create(base?: DeepPartial<CreateApplianceRequest>): CreateApplianceRequest {
    return CreateApplianceRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateApplianceRequest>): CreateApplianceRequest {
    const message = createBaseCreateApplianceRequest();
    message.name = object.name ?? "";
    message.category = object.category ?? undefined;
    message.manufacturer = object.manufacturer ?? undefined;
    message.model_number = object.model_number ?? undefined;
    message.location = object.location ?? undefined;
    message.install_date = object.install_date ?? undefined;
    message.warranty_until = object.warranty_until ?? undefined;
    message.notes = object.notes ?? undefined;
    return message;
  },
};

function createBaseUpdateApplianceRequest(): UpdateApplianceRequest {
  return {
    name: undefined,
    category: undefined,
    manufacturer: undefined,
    model_number: undefined,
    location: undefined,
    install_date: undefined,
    warranty_until: undefined,
    notes: undefined,
  };
}

export const UpdateApplianceRequest: MessageFns<UpdateApplianceRequest> = {
  encode(message: UpdateApplianceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    if (message.category !== undefined) {
      writer.uint32(18).string(message.category);
    }
    if (message.manufacturer !== undefined) {
      writer.uint32(26).string(message.manufacturer);
    }
    if (message.model_number !== undefined) {
      writer.uint32(34).string(message.model_number);
    }
    if (message.location !== undefined) {
      writer.uint32(42).string(message.location);
    }
    if (message.install_date !== undefined) {
      writer.uint32(50).string(message.install_date);
    }
    if (message.warranty_until !== undefined) {
      writer.uint32(58).string(message.warranty_until);
    }
    if (message.notes !== undefined) {
      writer.uint32(66).string(message.notes);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateApplianceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateApplianceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.category = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.manufacturer = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.model_number = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.location = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.install_date = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.warranty_until = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.notes = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateApplianceRequest {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      category: isSet(object.category) ? globalThis.String(object.category) : undefined,
      manufacturer: isSet(object.manufacturer) ? globalThis.String(object.manufacturer) : undefined,
      model_number: isSet(object.model_number) ? globalThis.String(object.model_number) : undefined,
      location: isSet(object.location) ? globalThis.String(object.location) : undefined,
      install_date: isSet(object.install_date) ? globalThis.String(object.install_date) : undefined,
      warranty_until: isSet(object.warranty_until) ? globalThis.String(object.warranty_until) : undefined,
      notes: isSet(object.notes) ? globalThis.String(object.notes) : undefined,
    };
  },

  toJSON(message: UpdateApplianceRequest): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.category !== undefined) {
      obj.category = message.category;
    }
    if (message.manufacturer !== undefined) {
      obj.manufacturer = message.manufacturer;
    }
    if (message.model_number !== undefined) {
      obj.model_number = message.model_number;
    }
    if (message.location !== undefined) {
      obj.location = message.location;
    }
    if (message.install_date !== undefined) {
      obj.install_date = message.install_date;
    }
    if (message.warranty_until !== undefined) {
      obj.warranty_until = message.warranty_until;
    }
    if (message.notes !== undefined) {
      obj.notes = message.notes;
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateApplianceRequest>): UpdateApplianceRequest {
    return UpdateApplianceRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateApplianceRequest>): UpdateApplianceRequest {
    const message = createBaseUpdateApplianceRequest();
    message.name = object.name ?? undefined;
    message.category = object.category ?? undefined;
    message.manufacturer = object.manufacturer ?? undefined;
    message.model_number = object.model_number ?? undefined;
    message.location = object.location ?? undefined;
    message.install_date = object.install_date ?? undefined;
    message.warranty_until = object.warranty_until ?? undefined;
    message.notes = object.notes ?? undefined;
    return message;
  },
};

function createBaseCreateServiceRecordRequest(): CreateServiceRecordRequest {
  return {
    service_type: "",
    contractor_name: undefined,
    cost: undefined,
    scheduled_at: undefined,
    next_due_date: undefined,
    notes: undefined,
  };
}

export const CreateServiceRecordRequest: MessageFns<CreateServiceRecordRequest> = {
  encode(message: CreateServiceRecordRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.service_type !== "") {
      writer.uint32(10).string(message.service_type);
    }
    if (message.contractor_name !== undefined) {
      writer.uint32(18).string(message.contractor_name);
    }
    if (message.cost !== undefined) {
      writer.uint32(25).double(message.cost);
    }
    if (message.scheduled_at !== undefined) {
      Timestamp.encode(toTimestamp(message.scheduled_at), writer.uint32(34).fork()).join();
    }
    if (message.next_due_date !== undefined) {
      Timestamp.encode(toTimestamp(message.next_due_date), writer.uint32(42).fork()).join();
    }
    if (message.notes !== undefined) {
      writer.uint32(50).string(message.notes);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateServiceRecordRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateServiceRecordRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.service_type = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.contractor_name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.cost = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.scheduled_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.next_due_date = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.notes = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateServiceRecordRequest {
    return {
      service_type: isSet(object.service_type) ? globalThis.String(object.service_type) : "",
      contractor_name: isSet(object.contractor_name) ? globalThis.String(object.contractor_name) : undefined,
      cost: isSet(object.cost) ? globalThis.Number(object.cost) : undefined,
      scheduled_at: isSet(object.scheduled_at) ? globalThis.String(object.scheduled_at) : undefined,
      next_due_date: isSet(object.next_due_date) ? globalThis.String(object.next_due_date) : undefined,
      notes: isSet(object.notes) ? globalThis.String(object.notes) : undefined,
    };
  },

  toJSON(message: CreateServiceRecordRequest): unknown {
    const obj: any = {};
    if (message.service_type !== "") {
      obj.service_type = message.service_type;
    }
    if (message.contractor_name !== undefined) {
      obj.contractor_name = message.contractor_name;
    }
    if (message.cost !== undefined) {
      obj.cost = message.cost;
    }
    if (message.scheduled_at !== undefined) {
      obj.scheduled_at = message.scheduled_at;
    }
    if (message.next_due_date !== undefined) {
      obj.next_due_date = message.next_due_date;
    }
    if (message.notes !== undefined) {
      obj.notes = message.notes;
    }
    return obj;
  },

  create(base?: DeepPartial<CreateServiceRecordRequest>): CreateServiceRecordRequest {
    return CreateServiceRecordRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateServiceRecordRequest>): CreateServiceRecordRequest {
    const message = createBaseCreateServiceRecordRequest();
    message.service_type = object.service_type ?? "";
    message.contractor_name = object.contractor_name ?? undefined;
    message.cost = object.cost ?? undefined;
    message.scheduled_at = object.scheduled_at ?? undefined;
    message.next_due_date = object.next_due_date ?? undefined;
    message.notes = object.notes ?? undefined;
    return message;
  },
};

function createBaseApplianceListResponse(): ApplianceListResponse {
  return { items: [] };
}

export const ApplianceListResponse: MessageFns<ApplianceListResponse> = {
  encode(message: ApplianceListResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      Appliance.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApplianceListResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApplianceListResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.items.push(Appliance.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApplianceListResponse {
    return {
      items: globalThis.Array.isArray(object?.items) ? object.items.map((e: any) => Appliance.fromJSON(e)) : [],
    };
  },

  toJSON(message: ApplianceListResponse): unknown {
    const obj: any = {};
    if (message.items?.length) {
      obj.items = message.items.map((e) => Appliance.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ApplianceListResponse>): ApplianceListResponse {
    return ApplianceListResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ApplianceListResponse>): ApplianceListResponse {
    const message = createBaseApplianceListResponse();
    message.items = object.items?.map((e) => Appliance.fromPartial(e)) || [];
    return message;
  },
};

function createBaseServiceRecordListResponse(): ServiceRecordListResponse {
  return { items: [] };
}

export const ServiceRecordListResponse: MessageFns<ServiceRecordListResponse> = {
  encode(message: ServiceRecordListResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      ServiceRecord.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServiceRecordListResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServiceRecordListResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.items.push(ServiceRecord.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServiceRecordListResponse {
    return {
      items: globalThis.Array.isArray(object?.items) ? object.items.map((e: any) => ServiceRecord.fromJSON(e)) : [],
    };
  },

  toJSON(message: ServiceRecordListResponse): unknown {
    const obj: any = {};
    if (message.items?.length) {
      obj.items = message.items.map((e) => ServiceRecord.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ServiceRecordListResponse>): ServiceRecordListResponse {
    return ServiceRecordListResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ServiceRecordListResponse>): ServiceRecordListResponse {
    const message = createBaseServiceRecordListResponse();
    message.items = object.items?.map((e) => ServiceRecord.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpcomingMaintenanceResponse(): UpcomingMaintenanceResponse {
  return { items: [] };
}

export const UpcomingMaintenanceResponse: MessageFns<UpcomingMaintenanceResponse> = {
  encode(message: UpcomingMaintenanceResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      UpcomingMaintenanceItem.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpcomingMaintenanceResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpcomingMaintenanceResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.items.push(UpcomingMaintenanceItem.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpcomingMaintenanceResponse {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => UpcomingMaintenanceItem.fromJSON(e))
        : [],
    };
  },

  toJSON(message: UpcomingMaintenanceResponse): unknown {
    const obj: any = {};
    if (message.items?.length) {
      obj.items = message.items.map((e) => UpcomingMaintenanceItem.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<UpcomingMaintenanceResponse>): UpcomingMaintenanceResponse {
    return UpcomingMaintenanceResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpcomingMaintenanceResponse>): UpcomingMaintenanceResponse {
    const message = createBaseUpcomingMaintenanceResponse();
    message.items = object.items?.map((e) => UpcomingMaintenanceItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseApplianceTodosResponse(): ApplianceTodosResponse {
  return { todos: [] };
}

export const ApplianceTodosResponse: MessageFns<ApplianceTodosResponse> = {
  encode(message: ApplianceTodosResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.todos) {
      Todo.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApplianceTodosResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApplianceTodosResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.todos.push(Todo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApplianceTodosResponse {
    return { todos: globalThis.Array.isArray(object?.todos) ? object.todos.map((e: any) => Todo.fromJSON(e)) : [] };
  },

  toJSON(message: ApplianceTodosResponse): unknown {
    const obj: any = {};
    if (message.todos?.length) {
      obj.todos = message.todos.map((e) => Todo.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ApplianceTodosResponse>): ApplianceTodosResponse {
    return ApplianceTodosResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ApplianceTodosResponse>): ApplianceTodosResponse {
    const message = createBaseApplianceTodosResponse();
    message.todos = object.todos?.map((e) => Todo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetApplianceRequest(): GetApplianceRequest {
  return { id: "" };
}

export const GetApplianceRequest: MessageFns<GetApplianceRequest> = {
  encode(message: GetApplianceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetApplianceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetApplianceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetApplianceRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: GetApplianceRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<GetApplianceRequest>): GetApplianceRequest {
    return GetApplianceRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetApplianceRequest>): GetApplianceRequest {
    const message = createBaseGetApplianceRequest();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseUpdateAppliancePathRequest(): UpdateAppliancePathRequest {
  return {
    id: "",
    name: undefined,
    category: undefined,
    manufacturer: undefined,
    model_number: undefined,
    location: undefined,
    install_date: undefined,
    warranty_until: undefined,
    notes: undefined,
  };
}

export const UpdateAppliancePathRequest: MessageFns<UpdateAppliancePathRequest> = {
  encode(message: UpdateAppliancePathRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.category !== undefined) {
      writer.uint32(26).string(message.category);
    }
    if (message.manufacturer !== undefined) {
      writer.uint32(34).string(message.manufacturer);
    }
    if (message.model_number !== undefined) {
      writer.uint32(42).string(message.model_number);
    }
    if (message.location !== undefined) {
      writer.uint32(50).string(message.location);
    }
    if (message.install_date !== undefined) {
      writer.uint32(58).string(message.install_date);
    }
    if (message.warranty_until !== undefined) {
      writer.uint32(66).string(message.warranty_until);
    }
    if (message.notes !== undefined) {
      writer.uint32(74).string(message.notes);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateAppliancePathRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateAppliancePathRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.category = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.manufacturer = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.model_number = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.location = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.install_date = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.warranty_until = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.notes = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateAppliancePathRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      category: isSet(object.category) ? globalThis.String(object.category) : undefined,
      manufacturer: isSet(object.manufacturer) ? globalThis.String(object.manufacturer) : undefined,
      model_number: isSet(object.model_number) ? globalThis.String(object.model_number) : undefined,
      location: isSet(object.location) ? globalThis.String(object.location) : undefined,
      install_date: isSet(object.install_date) ? globalThis.String(object.install_date) : undefined,
      warranty_until: isSet(object.warranty_until) ? globalThis.String(object.warranty_until) : undefined,
      notes: isSet(object.notes) ? globalThis.String(object.notes) : undefined,
    };
  },

  toJSON(message: UpdateAppliancePathRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.category !== undefined) {
      obj.category = message.category;
    }
    if (message.manufacturer !== undefined) {
      obj.manufacturer = message.manufacturer;
    }
    if (message.model_number !== undefined) {
      obj.model_number = message.model_number;
    }
    if (message.location !== undefined) {
      obj.location = message.location;
    }
    if (message.install_date !== undefined) {
      obj.install_date = message.install_date;
    }
    if (message.warranty_until !== undefined) {
      obj.warranty_until = message.warranty_until;
    }
    if (message.notes !== undefined) {
      obj.notes = message.notes;
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateAppliancePathRequest>): UpdateAppliancePathRequest {
    return UpdateAppliancePathRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateAppliancePathRequest>): UpdateAppliancePathRequest {
    const message = createBaseUpdateAppliancePathRequest();
    message.id = object.id ?? "";
    message.name = object.name ?? undefined;
    message.category = object.category ?? undefined;
    message.manufacturer = object.manufacturer ?? undefined;
    message.model_number = object.model_number ?? undefined;
    message.location = object.location ?? undefined;
    message.install_date = object.install_date ?? undefined;
    message.warranty_until = object.warranty_until ?? undefined;
    message.notes = object.notes ?? undefined;
    return message;
  },
};

function createBaseDeleteApplianceRequest(): DeleteApplianceRequest {
  return { id: "" };
}

export const DeleteApplianceRequest: MessageFns<DeleteApplianceRequest> = {
  encode(message: DeleteApplianceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteApplianceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteApplianceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteApplianceRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: DeleteApplianceRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<DeleteApplianceRequest>): DeleteApplianceRequest {
    return DeleteApplianceRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeleteApplianceRequest>): DeleteApplianceRequest {
    const message = createBaseDeleteApplianceRequest();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseCreateServiceRecordPathRequest(): CreateServiceRecordPathRequest {
  return {
    id: "",
    service_type: "",
    contractor_name: undefined,
    cost: undefined,
    scheduled_at: undefined,
    next_due_date: undefined,
    notes: undefined,
  };
}

export const CreateServiceRecordPathRequest: MessageFns<CreateServiceRecordPathRequest> = {
  encode(message: CreateServiceRecordPathRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.service_type !== "") {
      writer.uint32(18).string(message.service_type);
    }
    if (message.contractor_name !== undefined) {
      writer.uint32(26).string(message.contractor_name);
    }
    if (message.cost !== undefined) {
      writer.uint32(33).double(message.cost);
    }
    if (message.scheduled_at !== undefined) {
      Timestamp.encode(toTimestamp(message.scheduled_at), writer.uint32(42).fork()).join();
    }
    if (message.next_due_date !== undefined) {
      Timestamp.encode(toTimestamp(message.next_due_date), writer.uint32(50).fork()).join();
    }
    if (message.notes !== undefined) {
      writer.uint32(58).string(message.notes);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateServiceRecordPathRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateServiceRecordPathRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.service_type = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.contractor_name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.cost = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.scheduled_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.next_due_date = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.notes = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateServiceRecordPathRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      service_type: isSet(object.service_type) ? globalThis.String(object.service_type) : "",
      contractor_name: isSet(object.contractor_name) ? globalThis.String(object.contractor_name) : undefined,
      cost: isSet(object.cost) ? globalThis.Number(object.cost) : undefined,
      scheduled_at: isSet(object.scheduled_at) ? globalThis.String(object.scheduled_at) : undefined,
      next_due_date: isSet(object.next_due_date) ? globalThis.String(object.next_due_date) : undefined,
      notes: isSet(object.notes) ? globalThis.String(object.notes) : undefined,
    };
  },

  toJSON(message: CreateServiceRecordPathRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.service_type !== "") {
      obj.service_type = message.service_type;
    }
    if (message.contractor_name !== undefined) {
      obj.contractor_name = message.contractor_name;
    }
    if (message.cost !== undefined) {
      obj.cost = message.cost;
    }
    if (message.scheduled_at !== undefined) {
      obj.scheduled_at = message.scheduled_at;
    }
    if (message.next_due_date !== undefined) {
      obj.next_due_date = message.next_due_date;
    }
    if (message.notes !== undefined) {
      obj.notes = message.notes;
    }
    return obj;
  },

  create(base?: DeepPartial<CreateServiceRecordPathRequest>): CreateServiceRecordPathRequest {
    return CreateServiceRecordPathRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateServiceRecordPathRequest>): CreateServiceRecordPathRequest {
    const message = createBaseCreateServiceRecordPathRequest();
    message.id = object.id ?? "";
    message.service_type = object.service_type ?? "";
    message.contractor_name = object.contractor_name ?? undefined;
    message.cost = object.cost ?? undefined;
    message.scheduled_at = object.scheduled_at ?? undefined;
    message.next_due_date = object.next_due_date ?? undefined;
    message.notes = object.notes ?? undefined;
    return message;
  },
};

function createBaseListServiceRecordsRequest(): ListServiceRecordsRequest {
  return { id: "" };
}

export const ListServiceRecordsRequest: MessageFns<ListServiceRecordsRequest> = {
  encode(message: ListServiceRecordsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListServiceRecordsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListServiceRecordsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListServiceRecordsRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: ListServiceRecordsRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<ListServiceRecordsRequest>): ListServiceRecordsRequest {
    return ListServiceRecordsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListServiceRecordsRequest>): ListServiceRecordsRequest {
    const message = createBaseListServiceRecordsRequest();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseGetServiceRecordRequest(): GetServiceRecordRequest {
  return { id: "", record_id: "" };
}

export const GetServiceRecordRequest: MessageFns<GetServiceRecordRequest> = {
  encode(message: GetServiceRecordRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.record_id !== "") {
      writer.uint32(18).string(message.record_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetServiceRecordRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetServiceRecordRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.record_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetServiceRecordRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      record_id: isSet(object.record_id) ? globalThis.String(object.record_id) : "",
    };
  },

  toJSON(message: GetServiceRecordRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.record_id !== "") {
      obj.record_id = message.record_id;
    }
    return obj;
  },

  create(base?: DeepPartial<GetServiceRecordRequest>): GetServiceRecordRequest {
    return GetServiceRecordRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetServiceRecordRequest>): GetServiceRecordRequest {
    const message = createBaseGetServiceRecordRequest();
    message.id = object.id ?? "";
    message.record_id = object.record_id ?? "";
    return message;
  },
};

function createBaseUpdateServiceRecordRequest(): UpdateServiceRecordRequest {
  return {
    id: "",
    record_id: "",
    service_type: undefined,
    contractor_name: undefined,
    cost: undefined,
    scheduled_at: undefined,
    completed_at: undefined,
    next_due_date: undefined,
    notes: undefined,
  };
}

export const UpdateServiceRecordRequest: MessageFns<UpdateServiceRecordRequest> = {
  encode(message: UpdateServiceRecordRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.record_id !== "") {
      writer.uint32(18).string(message.record_id);
    }
    if (message.service_type !== undefined) {
      writer.uint32(26).string(message.service_type);
    }
    if (message.contractor_name !== undefined) {
      writer.uint32(34).string(message.contractor_name);
    }
    if (message.cost !== undefined) {
      writer.uint32(41).double(message.cost);
    }
    if (message.scheduled_at !== undefined) {
      Timestamp.encode(toTimestamp(message.scheduled_at), writer.uint32(50).fork()).join();
    }
    if (message.completed_at !== undefined) {
      Timestamp.encode(toTimestamp(message.completed_at), writer.uint32(58).fork()).join();
    }
    if (message.next_due_date !== undefined) {
      Timestamp.encode(toTimestamp(message.next_due_date), writer.uint32(66).fork()).join();
    }
    if (message.notes !== undefined) {
      writer.uint32(74).string(message.notes);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateServiceRecordRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateServiceRecordRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.record_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.service_type = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.contractor_name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.cost = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.scheduled_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.completed_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.next_due_date = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.notes = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateServiceRecordRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      record_id: isSet(object.record_id) ? globalThis.String(object.record_id) : "",
      service_type: isSet(object.service_type) ? globalThis.String(object.service_type) : undefined,
      contractor_name: isSet(object.contractor_name) ? globalThis.String(object.contractor_name) : undefined,
      cost: isSet(object.cost) ? globalThis.Number(object.cost) : undefined,
      scheduled_at: isSet(object.scheduled_at) ? globalThis.String(object.scheduled_at) : undefined,
      completed_at: isSet(object.completed_at) ? globalThis.String(object.completed_at) : undefined,
      next_due_date: isSet(object.next_due_date) ? globalThis.String(object.next_due_date) : undefined,
      notes: isSet(object.notes) ? globalThis.String(object.notes) : undefined,
    };
  },

  toJSON(message: UpdateServiceRecordRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.record_id !== "") {
      obj.record_id = message.record_id;
    }
    if (message.service_type !== undefined) {
      obj.service_type = message.service_type;
    }
    if (message.contractor_name !== undefined) {
      obj.contractor_name = message.contractor_name;
    }
    if (message.cost !== undefined) {
      obj.cost = message.cost;
    }
    if (message.scheduled_at !== undefined) {
      obj.scheduled_at = message.scheduled_at;
    }
    if (message.completed_at !== undefined) {
      obj.completed_at = message.completed_at;
    }
    if (message.next_due_date !== undefined) {
      obj.next_due_date = message.next_due_date;
    }
    if (message.notes !== undefined) {
      obj.notes = message.notes;
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateServiceRecordRequest>): UpdateServiceRecordRequest {
    return UpdateServiceRecordRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateServiceRecordRequest>): UpdateServiceRecordRequest {
    const message = createBaseUpdateServiceRecordRequest();
    message.id = object.id ?? "";
    message.record_id = object.record_id ?? "";
    message.service_type = object.service_type ?? undefined;
    message.contractor_name = object.contractor_name ?? undefined;
    message.cost = object.cost ?? undefined;
    message.scheduled_at = object.scheduled_at ?? undefined;
    message.completed_at = object.completed_at ?? undefined;
    message.next_due_date = object.next_due_date ?? undefined;
    message.notes = object.notes ?? undefined;
    return message;
  },
};

function createBaseDeleteServiceRecordRequest(): DeleteServiceRecordRequest {
  return { id: "", record_id: "" };
}

export const DeleteServiceRecordRequest: MessageFns<DeleteServiceRecordRequest> = {
  encode(message: DeleteServiceRecordRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.record_id !== "") {
      writer.uint32(18).string(message.record_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteServiceRecordRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteServiceRecordRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.record_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteServiceRecordRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      record_id: isSet(object.record_id) ? globalThis.String(object.record_id) : "",
    };
  },

  toJSON(message: DeleteServiceRecordRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.record_id !== "") {
      obj.record_id = message.record_id;
    }
    return obj;
  },

  create(base?: DeepPartial<DeleteServiceRecordRequest>): DeleteServiceRecordRequest {
    return DeleteServiceRecordRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeleteServiceRecordRequest>): DeleteServiceRecordRequest {
    const message = createBaseDeleteServiceRecordRequest();
    message.id = object.id ?? "";
    message.record_id = object.record_id ?? "";
    return message;
  },
};

function createBaseResearchSource(): ResearchSource {
  return {
    id: "",
    url: "",
    title: "",
    kind: "",
    match_confidence: "",
    why_matches: "",
    storj_sha: "",
    content_type: "",
    byte_size: "0",
    fetch_error: "",
  };
}

export const ResearchSource: MessageFns<ResearchSource> = {
  encode(message: ResearchSource, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.url !== "") {
      writer.uint32(18).string(message.url);
    }
    if (message.title !== "") {
      writer.uint32(26).string(message.title);
    }
    if (message.kind !== "") {
      writer.uint32(34).string(message.kind);
    }
    if (message.match_confidence !== "") {
      writer.uint32(42).string(message.match_confidence);
    }
    if (message.why_matches !== "") {
      writer.uint32(50).string(message.why_matches);
    }
    if (message.storj_sha !== "") {
      writer.uint32(58).string(message.storj_sha);
    }
    if (message.content_type !== "") {
      writer.uint32(66).string(message.content_type);
    }
    if (message.byte_size !== "0") {
      writer.uint32(72).int64(message.byte_size);
    }
    if (message.fetch_error !== "") {
      writer.uint32(82).string(message.fetch_error);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResearchSource {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResearchSource();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.kind = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.match_confidence = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.why_matches = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.storj_sha = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.content_type = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.byte_size = reader.int64().toString();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.fetch_error = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ResearchSource {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
      match_confidence: isSet(object.match_confidence) ? globalThis.String(object.match_confidence) : "",
      why_matches: isSet(object.why_matches) ? globalThis.String(object.why_matches) : "",
      storj_sha: isSet(object.storj_sha) ? globalThis.String(object.storj_sha) : "",
      content_type: isSet(object.content_type) ? globalThis.String(object.content_type) : "",
      byte_size: isSet(object.byte_size) ? globalThis.String(object.byte_size) : "0",
      fetch_error: isSet(object.fetch_error) ? globalThis.String(object.fetch_error) : "",
    };
  },

  toJSON(message: ResearchSource): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.kind !== "") {
      obj.kind = message.kind;
    }
    if (message.match_confidence !== "") {
      obj.match_confidence = message.match_confidence;
    }
    if (message.why_matches !== "") {
      obj.why_matches = message.why_matches;
    }
    if (message.storj_sha !== "") {
      obj.storj_sha = message.storj_sha;
    }
    if (message.content_type !== "") {
      obj.content_type = message.content_type;
    }
    if (message.byte_size !== "0") {
      obj.byte_size = message.byte_size;
    }
    if (message.fetch_error !== "") {
      obj.fetch_error = message.fetch_error;
    }
    return obj;
  },

  create(base?: DeepPartial<ResearchSource>): ResearchSource {
    return ResearchSource.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ResearchSource>): ResearchSource {
    const message = createBaseResearchSource();
    message.id = object.id ?? "";
    message.url = object.url ?? "";
    message.title = object.title ?? "";
    message.kind = object.kind ?? "";
    message.match_confidence = object.match_confidence ?? "";
    message.why_matches = object.why_matches ?? "";
    message.storj_sha = object.storj_sha ?? "";
    message.content_type = object.content_type ?? "";
    message.byte_size = object.byte_size ?? "0";
    message.fetch_error = object.fetch_error ?? "";
    return message;
  },
};

function createBaseProposedTask(): ProposedTask {
  return { title: "", interval_rrule: "", description: "", source_url: "" };
}

export const ProposedTask: MessageFns<ProposedTask> = {
  encode(message: ProposedTask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }
    if (message.interval_rrule !== "") {
      writer.uint32(18).string(message.interval_rrule);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.source_url !== "") {
      writer.uint32(34).string(message.source_url);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProposedTask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProposedTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.interval_rrule = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.source_url = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProposedTask {
    return {
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      interval_rrule: isSet(object.interval_rrule) ? globalThis.String(object.interval_rrule) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      source_url: isSet(object.source_url) ? globalThis.String(object.source_url) : "",
    };
  },

  toJSON(message: ProposedTask): unknown {
    const obj: any = {};
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.interval_rrule !== "") {
      obj.interval_rrule = message.interval_rrule;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.source_url !== "") {
      obj.source_url = message.source_url;
    }
    return obj;
  },

  create(base?: DeepPartial<ProposedTask>): ProposedTask {
    return ProposedTask.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProposedTask>): ProposedTask {
    const message = createBaseProposedTask();
    message.title = object.title ?? "";
    message.interval_rrule = object.interval_rrule ?? "";
    message.description = object.description ?? "";
    message.source_url = object.source_url ?? "";
    return message;
  },
};

function createBaseResearchResult(): ResearchResult {
  return {
    id: "",
    appliance_id: "",
    status: "",
    matched: false,
    match_rationale: "",
    summary: "",
    error: "",
    workflow_id: "",
    sources: [],
    tasks: [],
    created_at: undefined,
    updated_at: undefined,
  };
}

export const ResearchResult: MessageFns<ResearchResult> = {
  encode(message: ResearchResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.appliance_id !== "") {
      writer.uint32(18).string(message.appliance_id);
    }
    if (message.status !== "") {
      writer.uint32(26).string(message.status);
    }
    if (message.matched !== false) {
      writer.uint32(32).bool(message.matched);
    }
    if (message.match_rationale !== "") {
      writer.uint32(42).string(message.match_rationale);
    }
    if (message.summary !== "") {
      writer.uint32(50).string(message.summary);
    }
    if (message.error !== "") {
      writer.uint32(58).string(message.error);
    }
    if (message.workflow_id !== "") {
      writer.uint32(66).string(message.workflow_id);
    }
    for (const v of message.sources) {
      ResearchSource.encode(v!, writer.uint32(74).fork()).join();
    }
    for (const v of message.tasks) {
      ProposedTask.encode(v!, writer.uint32(82).fork()).join();
    }
    if (message.created_at !== undefined) {
      Timestamp.encode(toTimestamp(message.created_at), writer.uint32(90).fork()).join();
    }
    if (message.updated_at !== undefined) {
      Timestamp.encode(toTimestamp(message.updated_at), writer.uint32(98).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResearchResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResearchResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.appliance_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.status = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.matched = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.match_rationale = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.summary = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.error = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.workflow_id = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.sources.push(ResearchSource.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.tasks.push(ProposedTask.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.created_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.updated_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ResearchResult {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      appliance_id: isSet(object.appliance_id) ? globalThis.String(object.appliance_id) : "",
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      matched: isSet(object.matched) ? globalThis.Boolean(object.matched) : false,
      match_rationale: isSet(object.match_rationale) ? globalThis.String(object.match_rationale) : "",
      summary: isSet(object.summary) ? globalThis.String(object.summary) : "",
      error: isSet(object.error) ? globalThis.String(object.error) : "",
      workflow_id: isSet(object.workflow_id) ? globalThis.String(object.workflow_id) : "",
      sources: globalThis.Array.isArray(object?.sources)
        ? object.sources.map((e: any) => ResearchSource.fromJSON(e))
        : [],
      tasks: globalThis.Array.isArray(object?.tasks) ? object.tasks.map((e: any) => ProposedTask.fromJSON(e)) : [],
      created_at: isSet(object.created_at) ? globalThis.String(object.created_at) : undefined,
      updated_at: isSet(object.updated_at) ? globalThis.String(object.updated_at) : undefined,
    };
  },

  toJSON(message: ResearchResult): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.appliance_id !== "") {
      obj.appliance_id = message.appliance_id;
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.matched !== false) {
      obj.matched = message.matched;
    }
    if (message.match_rationale !== "") {
      obj.match_rationale = message.match_rationale;
    }
    if (message.summary !== "") {
      obj.summary = message.summary;
    }
    if (message.error !== "") {
      obj.error = message.error;
    }
    if (message.workflow_id !== "") {
      obj.workflow_id = message.workflow_id;
    }
    if (message.sources?.length) {
      obj.sources = message.sources.map((e) => ResearchSource.toJSON(e));
    }
    if (message.tasks?.length) {
      obj.tasks = message.tasks.map((e) => ProposedTask.toJSON(e));
    }
    if (message.created_at !== undefined) {
      obj.created_at = message.created_at;
    }
    if (message.updated_at !== undefined) {
      obj.updated_at = message.updated_at;
    }
    return obj;
  },

  create(base?: DeepPartial<ResearchResult>): ResearchResult {
    return ResearchResult.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ResearchResult>): ResearchResult {
    const message = createBaseResearchResult();
    message.id = object.id ?? "";
    message.appliance_id = object.appliance_id ?? "";
    message.status = object.status ?? "";
    message.matched = object.matched ?? false;
    message.match_rationale = object.match_rationale ?? "";
    message.summary = object.summary ?? "";
    message.error = object.error ?? "";
    message.workflow_id = object.workflow_id ?? "";
    message.sources = object.sources?.map((e) => ResearchSource.fromPartial(e)) || [];
    message.tasks = object.tasks?.map((e) => ProposedTask.fromPartial(e)) || [];
    message.created_at = object.created_at ?? undefined;
    message.updated_at = object.updated_at ?? undefined;
    return message;
  },
};

function createBaseStartResearchResponse(): StartResearchResponse {
  return { workflow_id: "", research_id: "" };
}

export const StartResearchResponse: MessageFns<StartResearchResponse> = {
  encode(message: StartResearchResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.workflow_id !== "") {
      writer.uint32(10).string(message.workflow_id);
    }
    if (message.research_id !== "") {
      writer.uint32(18).string(message.research_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartResearchResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartResearchResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.workflow_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.research_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartResearchResponse {
    return {
      workflow_id: isSet(object.workflow_id) ? globalThis.String(object.workflow_id) : "",
      research_id: isSet(object.research_id) ? globalThis.String(object.research_id) : "",
    };
  },

  toJSON(message: StartResearchResponse): unknown {
    const obj: any = {};
    if (message.workflow_id !== "") {
      obj.workflow_id = message.workflow_id;
    }
    if (message.research_id !== "") {
      obj.research_id = message.research_id;
    }
    return obj;
  },

  create(base?: DeepPartial<StartResearchResponse>): StartResearchResponse {
    return StartResearchResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StartResearchResponse>): StartResearchResponse {
    const message = createBaseStartResearchResponse();
    message.workflow_id = object.workflow_id ?? "";
    message.research_id = object.research_id ?? "";
    return message;
  },
};

function createBaseApplyResearchRequest(): ApplyResearchRequest {
  return { id: "", research_id: "", tasks: [] };
}

export const ApplyResearchRequest: MessageFns<ApplyResearchRequest> = {
  encode(message: ApplyResearchRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.research_id !== "") {
      writer.uint32(18).string(message.research_id);
    }
    for (const v of message.tasks) {
      ProposedTask.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApplyResearchRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApplyResearchRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.research_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tasks.push(ProposedTask.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApplyResearchRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      research_id: isSet(object.research_id) ? globalThis.String(object.research_id) : "",
      tasks: globalThis.Array.isArray(object?.tasks) ? object.tasks.map((e: any) => ProposedTask.fromJSON(e)) : [],
    };
  },

  toJSON(message: ApplyResearchRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.research_id !== "") {
      obj.research_id = message.research_id;
    }
    if (message.tasks?.length) {
      obj.tasks = message.tasks.map((e) => ProposedTask.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ApplyResearchRequest>): ApplyResearchRequest {
    return ApplyResearchRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ApplyResearchRequest>): ApplyResearchRequest {
    const message = createBaseApplyResearchRequest();
    message.id = object.id ?? "";
    message.research_id = object.research_id ?? "";
    message.tasks = object.tasks?.map((e) => ProposedTask.fromPartial(e)) || [];
    return message;
  },
};

function createBaseApplyResearchResponse(): ApplyResearchResponse {
  return { created_todo_ids: [] };
}

export const ApplyResearchResponse: MessageFns<ApplyResearchResponse> = {
  encode(message: ApplyResearchResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.created_todo_ids) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApplyResearchResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApplyResearchResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.created_todo_ids.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApplyResearchResponse {
    return {
      created_todo_ids: globalThis.Array.isArray(object?.created_todo_ids)
        ? object.created_todo_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ApplyResearchResponse): unknown {
    const obj: any = {};
    if (message.created_todo_ids?.length) {
      obj.created_todo_ids = message.created_todo_ids;
    }
    return obj;
  },

  create(base?: DeepPartial<ApplyResearchResponse>): ApplyResearchResponse {
    return ApplyResearchResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ApplyResearchResponse>): ApplyResearchResponse {
    const message = createBaseApplyResearchResponse();
    message.created_todo_ids = object.created_todo_ids?.map((e) => e) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(dateStr: string): Timestamp {
  const date = new globalThis.Date(dateStr);
  const seconds = Math.trunc(date.getTime() / 1_000).toString();
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): string {
  let millis = (globalThis.Number(t.seconds) || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis).toISOString();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
